module.exports = __webpack_public_path__ + "static/media/Bunbury-Central.927d3ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Bunbury-Central.png
// module id = 335
// module chunks = 0